import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/base16/onedark.css';

const Express = () => {

	useEffect(() => {
		hljs.highlightAll();
	}, []);
	
const codice1 = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>
<body>
    <a href="http://www.google.com" target="_blank">Google</a>
    <p>Io sono una pagina web</p>
</body>
</html>`;

const codice2 = `//Ha il listen, quindi non serve importare il modulo http. Eviti anche di importare il modulo fs.
let express = require('express')
const app = express()

//Middleware (o endpoint). Vuole due parametri: url, callback (req, res).
//Possono essere creati con la funzione get (quando l'utente digita nella barra degli indirizzi l'url),
//post (quando l'utente passa i parametri al server tramite il form con method POST).
app.get('/',(req,res)=>{
    res.send("Home page")
})

app.get('/pagina2',(req,res)=>{
    res.send("Io sono la seconda pagina")
})

app.get('/pagina3',(req,res)=>{
    res.sendFile(__dirname + "/html/index.html") //percorso assoluto
})

var server = app.listen(3001, ()=>{
    console.log("Server in esecuzione")
})`;

const codice3 = `npm install express`;

const codice4 = `app.use(cors());
app.option("*", cors());

app.use(
    express.urlencoded({
        extended: true,
    })
);`;

const codice5 = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Express parametri POST</title>

    <script>
        const controllo =()=>{
            let prodotto = document.querySelector(".prod").value

            if(prodotto == ""){
                alert("errore")
            } else {
                let form = document.querySelector(".mioForm")
                form.submit()
            }
        }

    </script>
</head>
<body>
    <form action="http://localhost:3001/carica" method="POST" class="mioForm">
        <input type="text" name="prodotto" class="prod">
        <input onclick="controllo()" type="button" value="CARICA">
    </form>
</body>
</html>`;

const codice6 = `let express = require("express")
const cors = require("cors")

let app = express()

app.use(cors())
app.options('*', cors())
app.use(express.json())
app.use(express.urlencoded({
    extended: true
}))

app.post('/', (req, res) => {
    const prod = req.body.prodotto;

    res.write(prod + " è stato aggiunto con successo!");
});`;

  return (
    <div className="container-fluid">
    	<div className="div-intro">
			<div data-aos="fade-right">
			<h1>Express</h1>
			<hr className="underline" data-aos="fade-right"/>
			</div>
			<br/>
			<div data-aos="fade-right">
			<h4>Cos'è Express?</h4>
			<p>
Il modulo <strong>Express.js</strong> è un dispatcher e viene utilizzato per controllare gli url, ovvero per la gestione di più pagine. Non è nativo, infatti deve essere scaricato con il seguente comando:</p>
			</div>
<div data-aos="zoom-in">
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice3}
</code></pre>
</div>
<br />
<div data-aos="fade-right">
<h4>Progetto Express (<a href="Progetto_8_Express.zip" target="_blank" download>scarica qui <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708"/>
</svg></a>)</h4>
<p>Ecco un progetto contentente un esempio di utilizzo di Express:</p>
</div>
<div data-aos="zoom-in">
<i>index.html</i>
<pre className="outside-code-toolbar">
<code className="language-html inside-code-toolbar">
{codice1}
</code></pre>
</div>
<div data-aos="zoom-in">
<i>server.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice2}
</code></pre>
</div>
<br/><br/>
<div data-aos="fade-right">
<h4>Recupero dei parametri</h4>
<p>
Per recuperare i <strong>parametri</strong> con Express si può utilizzare la split (<i>se è una stringa</i>), oppure possono essere visti come json e per recuperarli basta mettere .nome_parametro .
</p>
</div>
<div data-aos="zoom-in">
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice4}
</code></pre>
</div>
<br />
<div data-aos="fade-right">
<h4>Progetto Express passaggio parametri (<a href="passaggioParametriExpress.zip" target="_blank" download>scarica qui <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708"/>
</svg></a>)</h4>
<p>
Ecco un progetto contentente un esempio di utilizzo di Express con il passaggio di parametri:
</p>
</div>
<div data-aos="zoom-in">
<i>index.html</i>
<pre className="outside-code-toolbar">
<code className="language-html inside-code-toolbar">
{codice5}
</code></pre>
</div>
<div data-aos="zoom-in">
<i>server.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice6}
</code></pre>
</div>
		</div>
    </div>
  );
};

export default Express;
